import { Link } from 'react-router';
import { capitalize } from 'lodash';

import { useSoftwareEscrow } from 'src/context/software-escrow';
import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { AgreementFormEnum, EscrowPartyTypeEnum } from 'src/graphql/schema';
import { PartyInvitationContainer } from 'src/containers/Escrow/Invitation';
import { EscrowDepositorCore } from 'src/containers/Escrow/Depositor';

const contentMap = {
  creator: {
    title: 'Depositor information and representatives',
    description:
      'Check your organization details and add the key points of contact and authorized signatories for this escrow.',
    noteText: (
      <>
        Once all parties approve the escrow, we’ll send e-signature requests via DropBox Sign to the designated
        signatories to make the agreement legally binding.
        <br />
        Need a different signing method or a hardcopy agreement?{' '}
        <Link to="/help-resources/contact-us" className="underline!">
          Contact us
        </Link>
        .
      </>
    ),
  },
  invitation: {
    title: 'Depositor information',
    description:
      'Add the depositor organization and their primary point of contact.  The depositor organization is entity responsible for depositing the software and related materials into escrow.',
    noteText:
      'The primary contact will be invited to the platform, and be able to add members, representatives and signatories for their organization.',
  },
};

const DepositorContent = () => {
  const {
    softwareEscrow: { id: escrowId, escrowInvitation, currentCompanyRole, depositor, policy, agreement },
  } = useSoftwareEscrow();

  if (!depositor) {
    const invitePartyType =
      currentCompanyRole === EscrowPartyTypeEnum.Beneficiary
        ? EscrowPartyTypeEnum.Depositor
        : EscrowPartyTypeEnum.Beneficiary;

    return (
      <div className="col-span-2 flex justify-center">
        <div className="w-[580px] max-w-full">
          <PartyInvitationContainer
            escrowId={escrowId}
            invitationId={escrowInvitation?.id ?? null}
            invitePartyType={invitePartyType}
            canInviteParty={policy[`invite${capitalize(invitePartyType)}`]}
          />
        </div>
      </div>
    );
  }

  return (
    <EscrowDepositorCore depositorId={depositor.id} escrowId={escrowId} agreementType={agreement.agreementForm!} />
  );
};

const SoftwareEscrowOnboardingDepositor = () => {
  const {
    softwareEscrow: { currentCompanyRole, agreement },
  } = useSoftwareEscrow();

  const isEscrowInvitation =
    currentCompanyRole !== EscrowPartyTypeEnum.Depositor && agreement!.agreementForm === AgreementFormEnum.Tripartite;

  const { title, description, noteText } = contentMap[isEscrowInvitation ? 'invitation' : 'creator'];

  return (
    <SoftwareOnboardingMain
      title={title}
      description={description}
      noteText={noteText}
      classes={{ wrapper: !isEscrowInvitation ? 'md:h-full min-h-fit' : '' }}
    >
      <div className="container mx-auto grow md:overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:h-full">
          <DepositorContent />
        </div>
      </div>
    </SoftwareOnboardingMain>
  );
};

export default SoftwareEscrowOnboardingDepositor;
